import { useTranslation } from 'react-i18next'
import { useScientificCorpora } from '@/hooks/useScientificCorpora'

export function CorpusContent() {
  const { t } = useTranslation()
  const { sections, allItems, isLoading, isError } = useScientificCorpora()
  const firstSection = sections[0]

  if (isLoading) {
    return (
      <div className="bg-card px-6 py-4">
        <p className="text-foreground text-center text-sm">
          {t('discover.sections.corpusSection.loading')}
        </p>
      </div>
    )
  }
  if (isError || !firstSection) {
    return (
      <div className="bg-card px-6 py-4">
        <p className="text-destructive text-center text-sm">
          {t('discover.sections.corpusSection.error')}
        </p>
      </div>
    )
  }

  return (
    <div className="bg-card px-6 py-4">
      <h2 className="mb-4 text-[24px] font-semibold" style={{ color: '#171721' }}>
        {firstSection.title}
      </h2>
      <div
        className="corpus-header mb-4 text-base leading-relaxed font-normal [&_li]:mb-1 [&_p]:mb-2 [&_strong]:font-semibold [&_ul]:list-disc [&_ul]:pl-6"
        style={{ color: '#171721' }}
        dangerouslySetInnerHTML={{ __html: firstSection.header }}
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {allItems.map(item => (
          <div key={item.id} className="flex items-center gap-4 px-4 py-10">
            <img
              src={item.image}
              alt=""
              width={103}
              height={100}
              className="h-[100px] w-[103px] shrink-0 object-contain"
            />
            <div
              className="min-w-0 flex-1 text-sm leading-relaxed [&_li]:mb-1 [&_p]:mb-2 [&_strong]:font-semibold [&_ul]:list-disc [&_ul]:pl-6"
              style={{ color: '#171721' }}
              dangerouslySetInnerHTML={{ __html: item.content }}
            />
          </div>
        ))}
      </div>
    </div>
  )
}
